import { Context } from '../server-middleware/context'
import { Props } from '../../src/preact-components/widget-header/index.sync'
import getConfig from './configCommunity'
import getHTMLFromUrl from './ssi'
import { tryOrDefault } from '../utils/promiseHelpers'

function generateConfig<T extends Props['headerType']> (type: T, config: Props['headerInfo'][`${T}Header`]): Props {
  const header = {
    headerType: type,
    headerInfo: {
      defaultHeader: {
        label: '',
        labelMobile: '',
        url: '',
        logoUrl: '',
        linkColor: '',
        backgroundColor: ''
      },
      ssiHeader: {
        html: ''
      },
      customHeader: {
        html: ''
      }
    },
    username: '',
    avatar: '',
    customerTitle: '',
    staticPath: ''
  }

  header.headerInfo[`${type}Header`] = config

  return header
}

export async function getHeaderConfiguration (context: Context): Promise<Props> {
  const type = await tryOrDefault(getConfig(context, 'community_header.type'), 'default', context.logger)
  if (type === 'ssi') {
    return generateConfig('ssi', {
      html: await getHTMLFromUrl(context, await getConfig(context, 'ssi.header_processed_url') || '')
    })
  } else if (type === 'custom') {
    return generateConfig('custom', {
      html: await tryOrDefault(getConfig(context, 'custom_header.html'), '', context.logger) || ''
    })
  }

  const [label, labelMobile, url, logoUrl, linkColor, backgroundColor] = (await Promise.allSettled([
    getConfig(context, 'header.label'),
    getConfig(context, 'header.labelMobile'),
    getConfig(context, 'header.url'),
    getConfig(context, 'header.logoUrl'),
    getConfig(context, 'header.linkColor'),
    getConfig(context, 'header.backgroundColor')
  ])).map((result) => {
    if (result.status === 'fulfilled') return result.value || ''
    return ''
  })

  return generateConfig('default', { label, labelMobile, url, logoUrl, linkColor, backgroundColor })
}
